import {
  faFacebook,
  faInstagram,
  faLinkedinIn,
} from '@fortawesome/free-brands-svg-icons';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import {
  IconStyled,
  SocialNetworkContainer,
} from './SocialNetworksStandard.styles';

const Icon = ({ iconName, link, hasMarginRight }) => (
  <IconStyled
    href={link}
    target="_blank"
    rel="noopener"
    hasMarginRight={hasMarginRight}
  >
    <FontAwesomeIcon icon={iconName} />
  </IconStyled>
);

Icon.propTypes = {
  iconName: PropTypes.object.isRequired,
  link: PropTypes.string.isRequired,
  hasMarginRight: PropTypes.bool,
};

export const SocialNetworksStandard = () => (
  <SocialNetworkContainer>
    <Icon
      iconName={faLinkedinIn}
      link="https://www.linkedin.com/company/standard-invest/"
      hasMarginRight
    />
    <Icon
      iconName={faInstagram}
      link="https://www.instagram.com/standardinvest.ao/"
      hasMarginRight
    />
    <Icon
      iconName={faFacebook}
      link="https://www.facebook.com/StandardInvest"
      hasMarginRight
    />
    <Icon iconName={faGlobe} link="https://standardinvest.co.ao" />
  </SocialNetworkContainer>
);
